/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './survey-comments.reducer';

export const SurveyCommentsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const surveyCommentsEntity = useAppSelector(state => state.surveyComments.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="surveyCommentsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.surveyComments.detail.title">SurveyComments</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.surveyComments.id">Id</Translate>
            </span>
          </dt>
          <dd>{surveyCommentsEntity.id}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.surveyComments.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{surveyCommentsEntity.comments}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.surveyComments.active">Active</Translate>
            </span>
          </dt>
          <dd>{surveyCommentsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.surveyComments.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{surveyCommentsEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.surveyComments.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{surveyCommentsEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.surveyComments.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{surveyCommentsEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.surveyComments.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{surveyCommentsEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surveyComments.surveyHeader">Survey Header</Translate>
          </dt>
          <dd>{surveyCommentsEntity.surveyHeader ? surveyCommentsEntity.surveyHeader.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/survey-comments" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/survey-comments/${surveyCommentsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SurveyCommentsDetail;
